import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';

const IMG_PATH = 'assets/HowToPlay';
const FALLBACK_IMAGE_NAME = 'HowToPlay';

const HowToPlay = () => {
	const { t, i18n } = useTranslation();
	const currentLanguage = i18n.resolvedLanguage;

	const handleImgError = React.useCallback((e) => {
		console.info('Failed to find image', e.target.src);
		e.target.src = `${IMG_PATH}/${FALLBACK_IMAGE_NAME}.png`;
	}, []);

	return (
		<div id="HowToPlay1" className="page1 paddingTop50">
			<div className="wrapperMedium">
				<PageTitle>
					<h1>{t('How To Play')}</h1>
				</PageTitle>

				<div>
					<img
						style={{
							width: '100%',
						}}
						src={`${IMG_PATH}/HowToPlay-${currentLanguage}.png`}
						onError={handleImgError}
					/>
				</div>

				<h2>{t('Objective')}:</h2>
				<p>{t('The main goal is to form sets (three or four cards of the same rank) and runs (three or more cards in sequence of the same suit).')} {t('The ultimate aim is to have as few unmatched cards as possible.')}</p>

				<h2>{t('Dealing')}:</h2>
				<p>{t('Gin Rummy is typically played with 2 players.')} {t('Each player is dealt 10 cards if there are only two players, and 7 cards if there are more.')}</p>

				<h2>{t('Melding')}:</h2>
				<p>{t('Players take turns to draw and discard cards, trying to form sets and runs.')} {t('When a player has a complete hand, they can "knock" to signal the end of the round.')}</p>

				<h2>{t('Knocking')}:</h2>
				<p>{t('To knock, a player must have a hand where the unmatched cards (deadwood) total 10 or fewer points.')} {t('Aces are worth 1 point, face cards are worth 10, and numbered cards are worth their face value.')} {t(`The opponent can lay off their unmatched cards onto the knocking player's sets and runs.`)}</p>

				<h2>{t('Scoring')}:</h2>
				<p>{t(`The player who knocks scores the difference in points between their deadwood and the opponent's deadwood.`)} {t(`If the opponent has no unmatched cards, it's called going "Gin," and the knocker is penalized.`)}</p>

				<h2>{t('Undercutting')}:</h2>
				<p>{t(`If the opponent can reduce their deadwood to fewer points than the knocker's, they score the difference and receive a 10-point bonus.`)}</p>

				<h2>{t('Gameplay')}:</h2>
				<p>{t('The game is played over several rounds, and the first player to reach a set number of points (commonly 100) wins.')}</p>

				<div style={{
					margin: '20px 0px',
				}}>-</div>
			</div>

		</div>
	);
};

export default React.memo(HowToPlay);
